import { gql } from 'graphql.macro';

export const toggleNotificationReadTemplate = gql`
    mutation toggleNotificationRead($id: ID!, $isRead: Boolean!) {
        toggleNotificationRead(id: $id, isRead: $isRead) {
            _id
            isRead
        }
    }
`;

export const setNotificationDoneTemplate = gql`
    mutation setNotificationDone($id: MongoDbObjectId!, $isDone: Boolean!) {
        setNotificationDone(id: $id, isDone: $isDone) {
            _id
            isDone
            doneAt
            resolution {
                comment
                updatedAt
            }
        }
    }
`;

export const updateNotificationResolutionTemplate = gql`
    mutation updateNotificationResolution($id: MongoDbObjectId!, $comment: String!) {
        updateNotificationResolution(id: $id, comment: $comment) {
            _id
            isDone
            resolution {
                comment
                updatedAt
            }
        }
    }
`;

export const markOrderInternalChatNotificationsAsReadTemplate = gql`
    mutation markOrderInternalChatNotificationsAsRead($orderId: MongoDbObjectId!) {
        markOrderInternalChatNotificationsAsRead(orderId: $orderId)
    }
`;

export const markOrderNotificationsAsReadTemplate = gql`
    mutation markOrderNotificationsAsRead($orderId: MongoDbObjectId!) {
        markOrderNotificationsAsRead(orderId: $orderId)
    }
`;
